import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { DynamoUser } from "../../../interfaces/SuperAdmin/Others/DynamoUser";
import { iDataUser } from "../../../interfaces/SuperAdmin/Pages/iDataUser";
import CognitoView from "./CognitoView";
import DynamoDBView from "./DynamoDBView";
import EstadoBadge, { getEstadoFromUser } from "./EstadoBadge";
import RDSView from "./RDSView";
import Actions from "./Actions";

const UserVersions = () => {
  const { rdsUser, cognitoCredentialsUser, cognitoProviderUser, dynamoUser } =
    useSingleUserControl();
  const [value, setValue] = useState(0);

  const estadoMap: Record<string, "success" | "warning" | "wrong" | "unknown"> =
    {
      Activo: "success",
      Inactivo: "warning",
      Eliminado: "wrong",
    };

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: 1,
        border: "1px solid #336B8780",
        borderRadius: "7px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        px: 3,
        py: 2,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Typography variant="h3" sx={{ fontSize: "24px", fontWeight: "600" }}>
          Autenticación
        </Typography>
        <Actions />
      </Box>

      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={false}
        textColor="inherit"
        TabIndicatorProps={{
          style: {
            backgroundColor: "#336B87",
            height: 2,
          },
        }}
        sx={{
          borderBottom: "1px solid #336B8780",
          ".MuiTabs-flexContainer": {
            justifyContent: "flex-start",
          },
          ".MuiTab-root": {
            color: "#5A5A5A",
            fontWeight: "bold",
            fontFamily: "Montserrat",
            fontSize: "16px",
            textTransform: "none",
            borderRight: "1px solid #336B8780",
            minWidth: "auto",
            px: 2,
            pt: "6px",
            pb: "4px",
            "&:last-of-type": {
              borderRight: "none",
            },
            "&:hover": {
              color: "#336B87",
            },
          },
          ".Mui-selected": {
            color: "#336B87",
          },
        }}
      >
        <Tab
          key="rds"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              RDS
              <EstadoBadge
                estado={estadoMap[(rdsUser as iDataUser)?.estado] ?? "unknown"}
              >
                {rdsUser?.estado}
              </EstadoBadge>
            </Box>
          }
        />
        <Tab
          key="credentials"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              Cognito (credenciales)
              <EstadoBadge estado={getEstadoFromUser(cognitoCredentialsUser)} />
            </Box>
          }
        />
        <Tab
          key="provider"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              Cognito (proveedor)
              <EstadoBadge estado={getEstadoFromUser(cognitoProviderUser)} />
            </Box>
          }
        />
        <Tab
          key="dynamo"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              DynamoDB
              <EstadoBadge
                estado={getEstadoFromUser(dynamoUser as DynamoUser)}
              />
            </Box>
          }
        />
      </Tabs>
      {value === 0 && <RDSView />}
      {value === 1 && (
        <CognitoView user={cognitoCredentialsUser} type="credentials" />
      )}
      {value === 2 && (
        <CognitoView user={cognitoProviderUser} type="provider" />
      )}
      {value === 3 && <DynamoDBView />}
    </Box>
  );
};

export default UserVersions;
